import React from "react";
import { FormControl, Select, MenuItem, FormHelperText, Input } from "@mui/material";

const countryCodes = [
  { code: "91", label: "IN" },
  // { code: "1", label: "US" },
  // { code: "44", label: "UK" },
  // { code: "61", label: "AU" },
  // { code: "81", label: "JP" },
  // Add more country codes as needed
];

const PhoneNumberField = ({ value, onChange, error, helperText, style }) => {
  const [countryCode, setCountryCode] = React.useState("91");
  const [phoneNumber, setPhoneNumber] = React.useState("");

  React.useEffect(() => {
    // Split the value into country code and phone number if provided
    if (value) {
      const matchedCode = countryCodes.find((code) => value.startsWith(code.code));
      if (matchedCode) {
        setCountryCode(matchedCode.code);
        setPhoneNumber(value.replace(matchedCode.code, ""));
      } else {
        setPhoneNumber(value); // If no country code is matched, treat the entire value as the phone number
      }
    }
  }, [value]);

  const handleCountryCodeChange = (event) => {
    const newCountryCode = event.target.value;
    setCountryCode(newCountryCode);
    onChange({ countryCode: newCountryCode, phoneNumber }); // Send both country code and phone number
  };

  const handlePhoneNumberChange = (event) => {
    const newPhoneNumber = event.target.value;
    if (/^\d*$/.test(newPhoneNumber) && newPhoneNumber.length <= 10) {
      // Allow only digits and ensure the phone number is at most 10 digits
      setPhoneNumber(newPhoneNumber);
      onChange({ countryCode, phoneNumber: newPhoneNumber }); // Send both country code and phone number
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          textAlign: "start",
          marginTop: "10px",
          fontSize: "18px",
          fontWeight: "400",
          width: "100%",
        }}
      >
        <label>
          Phone Number
          <span
            className="mandatory"
            style={{ color: "red", marginLeft: "5px" }}
          >
            *
          </span>
        </label>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "100%" }}>
        {/* Country Code Dropdown */}
        <FormControl
          style={{
            minWidth: "100px",
            color: style?.color,
          }}
          variant="standard"
          error={error}
        >
          <Select
            value={countryCode}
            onChange={handleCountryCodeChange}
            style={{ color: style?.color, marginTop: "10px" }}
          >
            {countryCodes.map((country) => (
              <MenuItem key={country.code} value={country.code}>
                {country.label} ({"+"+ country.code})
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Phone Number Input Field */}
        <FormControl
          style={{
            flex: 1,
            color: style?.color,
          }}
          variant="standard"
          error={error}
        >
          <Input
            type="text"
            value={phoneNumber}
            onChange={handlePhoneNumberChange}
            inputProps={{ style: { color: style?.color } }}
            style={{ color: style?.color, width: "100%", marginTop: "10px" }}
          />
        </FormControl>
      </div>
      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </div>
  );
};

export default PhoneNumberField;